// extracted by mini-css-extract-plugin
module.exports = {"container":"DisplayCopyInput_container__1RLFz","text":"DisplayCopyInput_text__1XH1t"};